import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IDefaultAssembly } from 'src/interfaces';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export interface scheduleAssembliesTransaction {
  resource: string;
  method: string;
  id?: number;
  data: Partial<IDefaultAssembly>;
}

export const useCreateOrUpdateDefaultAssembly = () => {
  return useMutation({
    mutationFn: updateOrCreateDefaultAssemblies,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.scheduleDaypartAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleDayparts.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.defaultAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

async function updateOrCreateDefaultAssemblies(
  payload: scheduleAssembliesTransaction[],
) {
  const response = await requestCCApi({
    url: `/transaction`,
    method: 'POST',
    data: {
      data: payload,
    },
  });

  return response;
}
